import React from 'react'
import styles from './vinSearch.module.scss'
import useTranslation from '@/hooks/useTranslation'
import { Row, Col, Form, Loader } from 'rsuite'
import cn from 'classnames'
import LinkButton from '@/components/shared/linkButton'
import ShowVinInfoModal from '@/components/shared/showVinInfoModal'
import { ActionButton } from '@/components/styles'
import DirectionalArrow from '@/components/themes/common/icons/directionalArrow'

const DefaultVinSearch = ({
  showVINInfo,
  setShowVINInfo,
  vin,
  setVin,
  setVINError,
  loadingVIN,
  VINError,
  decodeVinFn,
  showActionIcon
}) => {
  const t = useTranslation()
  return (
    <Row>
      <Col md={22}>
        <ShowVinInfoModal show={showVINInfo} onHide={() => setShowVINInfo(false)} />
        <h4 id="enterVIN" className={cn('mt-20', styles.enterVin)}>
          {t('homepage_enter_vin_number')}
        </h4>
        <Form layout="inline" className={cn('mb-20', styles.vinForm)}>
          <Form.Group>
            <Form.Control
              className={cn(styles.searchVinInput, 'mr-10')}
              name="VIN"
              placeholder={t('homepage_enter_vin_placeholder')}
              maxLength={17}
              onChange={value => {
                setVin(value)
                setVINError(false)
              }}
              value={vin}
            />
            {loadingVIN && <Loader />}
            {VINError && <span className={cn(styles.vinError)}>{t(VINError)}</span>}
            <Form.HelpText className="mt-10 vinLocation">
              <LinkButton size="md" appearance="link" onClick={() => setShowVINInfo(true)}>
                {t('homepage_where_to_find_vin')}
              </LinkButton>
            </Form.HelpText>
            <ActionButton
              $withIcon={showActionIcon}
              className="mt-20"
              appearance="primary"
              onClick={decodeVinFn}
              disabled={!vin || vin.length < 17 || loadingVIN}
            >
              {t('look_up_vehicle')} {showActionIcon && <DirectionalArrow size={16} className="fix-btn-icon" />}
            </ActionButton>
          </Form.Group>
        </Form>
      </Col>
      <Col md={2} />
    </Row>
  )
}

export default DefaultVinSearch
